import { render, staticRenderFns } from "./brand-detail.vue?vue&type=template&id=cacad4f6&scoped=true&"
import script from "./brand-detail.vue?vue&type=script&lang=js&"
export * from "./brand-detail.vue?vue&type=script&lang=js&"
import style0 from "./brand-detail.vue?vue&type=style&index=0&id=cacad4f6&lang=scss&scoped=true&"
import style1 from "./brand-detail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cacad4f6",
  null
  
)

export default component.exports